<span [ngClass]="{ ok: okStatus, attention: attentionStatus, error: errorStatus }">{{
  message.gungEdiMessageSendStatus | uppercase | translate
}} @if(message.sentTimestamp) { - {{ message.sentTimestamp | date : 'yyyy-MM-dd HH:mm' }} }</span>